module.exports = new __parcel__URL__("Frame-3.fedca028.svg").toString();